export const GET_REPORT_TRIP_REQUEST = 'GET_REPORT_TRIP_REQUEST' as const;
export const GET_REPORT_TRIP_SUCCESS = 'GET_REPORT_TRIP_SUCCESS' as const;
export const GET_REPORT_TRIP_ERROR = 'GET_REPORT_TRIP_ERROR' as const;
export const CLEAR_REPORT_PHOTO = 'CLEAR_REPORT_PHOTO' as const;
